import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-start items-start" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center h-[72px] w-[72px]"
}
const _hoisted_3 = { class: "grow shrink basis-0 bg-white flex-col justify-start items-start gap-1 inline-flex" }

import { computed } from 'vue';
import { RichText, Field, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProofpointSet',
  props: {
    fields: {},
    quoteType: {}
  },
  setup(__props: any) {

const props = __props;

const filteredFields = computed(() =>
  props.fields.fields.filter((field) =>
    field.showForPolicyTypes.find((item) => item.fields.insuranceCoverageCode?.value === props.quoteType)
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFields.value, (row, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["px-2 py-6 bg-white justify-start items-center gap-4 inline-flex border-racq-pale-blue-border", index !== 0 ? 'border-t' : ''])
      }, [
        (row.icon?.value?.src)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Image), {
                media: row.icon
              }, null, 8, ["media"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(RichText), {
            field: row.title,
            class: "text-racq-dark-grey text-lg-bold"
          }, null, 8, ["field"]),
          _createVNode(_unref(RichText), {
            field: row.text,
            class: "text-racq-med-grey text-m"
          }, null, 8, ["field"])
        ])
      ], 2))
    }), 128)),
    _createVNode(_unref(RichText), {
      field: _ctx.fields.footerText,
      class: "text-racq-med-grey text-sm mt-2 md:mt-3"
    }, null, 8, ["field"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mt-8 bg-racq-anti-flash-white h-8 w-full" }, null, -1))
  ]))
}
}

})